import { defineComponent as a, useSlots as i, openBlock as l, createElementBlock as t, createElementVNode as s, renderSlot as o, unref as d, createCommentVNode as n } from "vue";
const c = { class: "flex grid-cols-2 flex-col md:grid md:h-full md:grid-cols-[1fr_360px]" }, m = { class: "relative max-h-full overflow-hidden bg-black" }, f = { class: "flex h-full flex-col overflow-y-auto bg-white p-4" }, u = {
  key: 0,
  class: "peer/meta"
}, _ = { key: 1 }, $ = /* @__PURE__ */ a({
  __name: "UserGallery",
  setup(h) {
    const r = i();
    return (e, p) => (l(), t("div", c, [
      s("div", m, [
        o(e.$slots, "gallery")
      ]),
      s("div", f, [
        o(e.$slots, "header"),
        s("div", null, [
          o(e.$slots, "default")
        ]),
        d(r).meta ? (l(), t("div", u, [
          o(e.$slots, "meta")
        ])) : n("", !0),
        o(e.$slots, "footer"),
        s("div", null, [
          o(e.$slots, "actions")
        ]),
        d(r).comments ? (l(), t("div", _, [
          o(e.$slots, "comments")
        ])) : n("", !0)
      ])
    ]));
  }
});
export {
  $ as _
};
